import { FormAdapter } from "hooks/useForm";
import { convertToBooleanSwitch } from "util/transformers";
import { WebRoutes } from "consts/enpoints/web";
import { ECommerceOnboardingFilableResource } from "consts/ecommerce";
import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant as HighRiskMerchantApi } from "features/ecommerce/api";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingFileUpload, useOnboardingForm, useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useMarketingWebsiteAndSupport = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingMarketingWebsiteAndSupport>();

    const uploadFiles = useOnboardingFileUpload();

    const withValues = useOnboardingForm({
        save: HighRiskMerchantApi.putOnboardingsHighRiskMarketingAndSupportSteps,
        route: WebRoutes.Onboarding.HighRiskMerchant,
        getApplicationModel
    });

    const formProps: HighRiskMerchant.MarketingWebsiteAndSupport.OnboardingMarketingWebsiteAndSupportForm = {
        bootstrapData: {},
        initialValues: HighRiskMerchant.MarketingWebsiteAndSupport.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: async ({
            refundChargebackPoliciesFileKey,
            hasCreditLimitPolicy,
            creditLimitPolicyInput,
            fraudToolsInput,
            wasTerminatedByAcquirer,
            terminatedByAcquirerInput,
            doesCollectKyc,
            doesCollectKycViaOther,
            collectKycViaOtherInput,
            hasFullTimeCustomerSupport,
            fullTimeCustomerSupportInput,
            customerSupportEmail,
            refundChargebackPolicies,
            securityRiskManagementInput,
            otherSecurityRiskInput
        }, helpers) => {
            try {
                await uploadFiles({
                    resource: ECommerceOnboardingFilableResource.ClientMarketingSupportSteps
                }, [
                    refundChargebackPoliciesFileKey, HighRiskMerchant.MarketingWebsiteAndSupport.FormField.RefundChargebackPoliciesFileKey
                ]);

                return withValues({
                    hasCreditLimitPolicy: convertToBooleanSwitch(hasCreditLimitPolicy),
                    wasTerminatedByAcquirer: convertToBooleanSwitch(wasTerminatedByAcquirer),
                    doesCollectKyc: convertToBooleanSwitch(doesCollectKyc),
                    doesCollectKycViaOther: convertToBooleanSwitch(doesCollectKycViaOther),
                    hasFullTimeCustomerSupport: convertToBooleanSwitch(hasFullTimeCustomerSupport),
                    creditLimitPolicyInput,
                    fraudToolsInput,
                    terminatedByAcquirerInput,
                    collectKycViaOtherInput,
                    fullTimeCustomerSupportInput,
                    customerSupportEmail,
                    refundChargebackPolicies,
                    refundChargebackPoliciesFileKey,
                    securityRiskManagementInput,
                    otherSecurityRiskInput
                }, helpers);
            } catch (failedfileResponse) {
                return FormAdapter.fromResponse(failedfileResponse)
            }
        }
    };

    return {
        ...formProps,
        ...HighRiskMerchant.MarketingWebsiteAndSupport.useForm(formProps),
        ...data
    };
};

export default useMarketingWebsiteAndSupport;
